var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCallToken = function SvgCallToken(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3664 0L7.20551 0.546885V16.4162L7.3664 16.5768L14.7328 12.2226L7.3664 0Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36637 0L0 12.2226L7.36637 16.5769V8.87439V0Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.366 17.9715L7.27533 18.0821V23.7351L7.366 23.9999L14.7367 13.6195L7.366 17.9715Z",
    fill: "#3C3C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36637 23.9999V17.9715L0 13.6194L7.36637 23.9999Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36615 16.5769L14.7324 12.2228L7.36615 8.87455V16.5769Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2228L7.36626 16.5769V8.87455L0 12.2228Z",
    fill: "#393939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 18.8572C18.8571 21.6975 16.5545 24.0001 13.7142 24.0001C10.8739 24.0001 8.57135 21.6975 8.57135 18.8572C8.57135 16.0169 10.8739 13.7143 13.7142 13.7143C16.5545 13.7143 18.8571 16.0169 18.8571 18.8572Z",
    fill: "#030303"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7142 23.4858C16.2705 23.4858 18.3428 21.4135 18.3428 18.8572C18.3428 16.3009 16.2705 14.2286 13.7142 14.2286C11.1579 14.2286 9.08564 16.3009 9.08564 18.8572C9.08564 21.4135 11.1579 23.4858 13.7142 23.4858ZM13.7142 24.0001C16.5545 24.0001 18.8571 21.6975 18.8571 18.8572C18.8571 16.0169 16.5545 13.7143 13.7142 13.7143C10.8739 13.7143 8.57135 16.0169 8.57135 18.8572C8.57135 21.6975 10.8739 24.0001 13.7142 24.0001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7999 16.2857C13.6105 16.2857 13.457 16.4392 13.457 16.6286V18.6258H11.4857C11.2963 18.6258 11.1428 18.7793 11.1428 18.9686C11.1428 19.158 11.2963 19.3115 11.4857 19.3115H13.457V21.0857C13.457 21.2751 13.6105 21.4286 13.7999 21.4286C13.9892 21.4286 14.1427 21.2751 14.1427 21.0857V19.3115H15.9428C16.1322 19.3115 16.2857 19.158 16.2857 18.9686C16.2857 18.7793 16.1322 18.6258 15.9428 18.6258H14.1427V16.6286C14.1427 16.4392 13.9892 16.2857 13.7999 16.2857Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCallToken, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/call_token.d821f03c.svg";
export { ForwardRef as ReactComponent };